import { useEffect, useState, type FormEvent } from 'react';
import { api, ApiError } from '../lib/api';

/** Invite token arrives in the URL fragment (never sent to servers in Referer/logs). */
export function Invite({ onDone }: { onDone: () => void }) {
  const token = location.hash.slice(1);
  const [form, setForm] = useState({ email: '', displayName: '', password: '' });
  const [error, setError] = useState<string | null>(null);
  const [googleOnly, setGoogleOnly] = useState(false);
  useEffect(() => {
    api
      .get<{ google: boolean; password: boolean }>('/v1/auth/config')
      .then((c) => setGoogleOnly(c.google && !c.password))
      .catch(() => undefined);
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.post('/v1/auth/invites/accept', { token, ...form });
      history.replaceState(null, '', '/');
      onDone();
    } catch (err) {
      const code = err instanceof ApiError ? err.code : '';
      setError(
        code === 'invalid_invite'
          ? 'Davet geçersiz, süresi dolmuş veya e-posta eşleşmiyor.'
          : code === 'account_exists_login_instead'
            ? 'Bu e-postayla hesap zaten var. Giriş yapın; proje yöneticisi sizi projeye ekleyebilir.'
            : 'Hesap oluşturulamadı. Parola en az 12 karakter olmalı.',
      );
    }
  }

  if (googleOnly)
    return (
      <main className="auth">
        <form onSubmit={(e) => e.preventDefault()}>
          <h1>Daveti kabul edin</h1>
          <p className="lede">
            Bu Converoom sunucusunda giriş Google hesabıyla yapılır. Davet edildiğiniz e-posta adresinin
            Google hesabıyla giriş yapmanız yeterli; hesabınız ve proje üyeliğiniz otomatik açılır.
          </p>
          <a
            className="btn primary"
            href="/v1/auth/google/start"
            style={{ width: '100%', justifyContent: 'center' }}
          >
            Google ile giriş yap
          </a>
        </form>
      </main>
    );

  return (
    <main className="auth">
      <form onSubmit={submit}>
        <h1>Daveti kabul edin</h1>
        <p className="lede">
          Hesabınız yalnızca size aittir; AI bağlantılarınızı ve bütçenizi siz yönetirsiniz.
        </p>
        {!token && <p className="error-text">Davet bağlantısı eksik.</p>}
        <label className="field">
          <span>Davet edilen e-posta</span>
          <input
            className="input"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
        </label>
        <label className="field">
          <span>Görünen ad</span>
          <input
            className="input"
            required
            maxLength={80}
            value={form.displayName}
            onChange={(e) => setForm({ ...form, displayName: e.target.value })}
          />
        </label>
        <label className="field">
          <span>Parola (en az 12 karakter)</span>
          <input
            className="input"
            type="password"
            minLength={12}
            autoComplete="new-password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
        </label>
        {error && (
          <p className="error-text" role="alert">
            {error}
          </p>
        )}
        <button className="btn primary" type="submit" disabled={!token}>
          Hesabı oluştur
        </button>
      </form>
    </main>
  );
}
